import { fetchWithToken } from "@platform/core";
import {
  WORKITEM_BFF_API_BASE_USERS,
  WORK_MANAGEMENT_ADMIN_BFF_API_BASE,
  WORK_MANAGEMENT_ADMIN_BFF_API_BASE_V2,
} from "../platform-workitems";
import { Dispatch, SetStateAction } from "react";
import { reportError } from "./errors";
import { BusinessProcess } from "../models/BusinessProcess";
import { ResolutionReason } from "../models/ReasonsAndResolutions";
import { Resource } from "../models/Resource";
import { WorkItemPageTypes } from "../models/WorkItemPageTypes";

export function fetchDataGridInitialData(
  typeOfWorkItemPage: string,
  setFunctions: Dispatch<SetStateAction<string[]>>,
  setProcesses: Dispatch<SetStateAction<string[]>>,
  setCompleteReasonCodes: Dispatch<SetStateAction<string[]>>,
  setCancelReasonCodes: Dispatch<SetStateAction<string[]>>,
  setResources: Dispatch<SetStateAction<{ value: string; label: string }[]>>,
  setWorkItemInteractionError: Dispatch<SetStateAction<string | null>>
) {
  (async () => {
    await fetchWithToken(`${WORK_MANAGEMENT_ADMIN_BFF_API_BASE}/business-functions`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(JSON.stringify(response));
        }
        return response.json();
      })
      .then((result) => {
        setFunctions(result || []);
      })
      .catch((error) => {
        setWorkItemInteractionError("Unable to get list of business functions. Please try again.");
        reportError(error.message);
      });
  })();

  (async () => {
    await fetchWithToken(`${WORK_MANAGEMENT_ADMIN_BFF_API_BASE_V2}/business-processes`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(JSON.stringify(response));
        }
        return response.json();
      })
      .then((result) => {
        const BusinessProcessList: string[] = [];
        result.filter((process: BusinessProcess) => {
          BusinessProcessList.push(process.BusinessProcess);
        });
        setProcesses(BusinessProcessList);
      })
      .catch((error) => {
        setWorkItemInteractionError("Unable to get list of business processes. Please try again.");
        reportError(error.message);
      });
  })();

  typeOfWorkItemPage == WorkItemPageTypes.InactivePage &&
    (async () => {
      await fetchWithToken(
        `${WORK_MANAGEMENT_ADMIN_BFF_API_BASE}/resolution-reasons?action=Complete`,
        {
          method: "GET",
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(JSON.stringify(response));
          }
          return response.json();
        })
        .then((result) => {
          const codes: string[] = [];

          result.forEach((reason: ResolutionReason) => {
            codes.push(reason.ResolutionReasonCode);
          });

          setCompleteReasonCodes(codes);
        })
        .catch((error) => {
          setWorkItemInteractionError(
            "Unable to get list of resolution reason codes. Please try again."
          );
          reportError(error.message);
        });
    })();

  typeOfWorkItemPage == WorkItemPageTypes.InactivePage &&
    (async () => {
      await fetchWithToken(
        `${WORK_MANAGEMENT_ADMIN_BFF_API_BASE}/resolution-reasons?action=Cancel`,
        {
          method: "GET",
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(JSON.stringify(response));
          }
          return response.json();
        })
        .then((result) => {
          const codes: string[] = [];

          result.forEach((reason: ResolutionReason) => {
            codes.push(reason.ResolutionReasonCode);
          });

          setCancelReasonCodes(codes);
        })
        .catch((error) => {
          setWorkItemInteractionError(
            "Unable to get list of resolution reason codes. Please try again."
          );
          reportError(error.message);
        });
    })();

  (typeOfWorkItemPage == WorkItemPageTypes.InactivePage || WorkItemPageTypes.ActivePage) &&
    (async () => {
      await fetchWithToken(`${WORKITEM_BFF_API_BASE_USERS}`, {
        method: "GET",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(JSON.stringify(response));
          }
          return response.json();
        })
        .then((result) => {
          result.sort((a: Resource, b: Resource) => a.FullName.localeCompare(b.FullName));
          const userList = result.map((user: Resource) => ({
            value: user.ResourceIdentifier,
            label: user.FullName,
          }));

          setResources(userList);
        })
        .catch((error) => {
          reportError(error);
        });
    })();
}
